<!-- 
Panel showing connectivity status for our 3rd party dependencies (HITS, Unistats, VSL DataMart and SAP)
-->
<template>
  <v-card
    class="mx-auto text-xs-center flat"
    style="background: transparent;"
    max-width="600"
  >
    <v-card-text class="pa-0">
      <v-progress-circular v-if="!state.loaded" indeterminate />
      <v-sheet v-if="state.loaded" style="background: transparent">
        <connectivity-item :connected="values.hits" :small="xs" title="HITS" subtitle="(Provider basic info & contacts)"/>
        <connectivity-item :connected="values.unistats" :small="xs" title="Unistats" subtitle="(HELP levy calculation parameters)"/>
        <connectivity-item :connected="values.vslDatamart" :small="xs" title="VSL Datamart" subtitle="(VSL levy calculation parameters)"/>
        <connectivity-item 
          v-if="sapUsingDummyGateway" 
          :small="xs" 
          not-applicable connected 
          title="SAP" subtitle="(currently using dummy gateway)"
        />
        <template v-else>
          <connectivity-item :connected="values.sapForHelp" :small="xs" title="SAP for HELP" subtitle="(Invoicing)"/>
          <connectivity-item :connected="values.sapForVsl" :small="xs" title="SAP for VSL" subtitle="(Invoicing)"/>
          <connectivity-item :connected="values.sapForUpfront" :small="xs" title="SAP for Up-front" subtitle="(Invoicing)"/>
        </template>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<script>
import ConnectivityItem from "./ConnectivityItem.vue";
import { CONNECTIVITY } from "@/store/exception-logs/action-types";

export default {
  components: { ConnectivityItem },
  computed: {
    state() {
      return this.$store.state.exceptionLogs.connectivity;
    },
    values() {
      return this.state.data;
    },
    sapUsingDummyGateway() {
      return this.$store.state.system.details.sap_using_dummy_gateway;
    },
    xs() {
      return this.$vuetify.breakpoint.xs;
    }
  },
  mounted() {
    this.$store.dispatch(CONNECTIVITY);
  }
};
</script>
